import React, { useEffect } from 'react';
import Alert from 'fe-design-base/molecules/Alert/Alert';

import { I18N_PATH } from 'features/team/components/TaxEntryForm/constants';
import { BANNER_VERSION } from 'features/teamView/tracking';

import { toI18n } from 'util/i18n';
import { EVENT_ACTIONS, TRACK_ACTION_TYPES } from 'util/tracking_constants';
import { useTrackUx } from 'util/uxEvents';

const NoAddressAlert = () => {
  const trackUx = useTrackUx();
  useEffect(() => {
    trackUx(EVENT_ACTIONS.BANNER_VIEWED, TRACK_ACTION_TYPES.VIEW, {
      banner_version: BANNER_VERSION.UNABLE_TO_FIND_AND_VERIFY_ADDRESS,
    });
  }, [trackUx]);

  return (
    <Alert
      variant="error"
      title={toI18n(`${I18N_PATH}.address_alerts.error.title`)}
    >
      {toI18n(`${I18N_PATH}.address_alerts.error.desc`)}
    </Alert>
  );
};

export default NoAddressAlert;
